var _polygon, _circle, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonorManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 38,
    r: 9,
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 33,
    x2: 50,
    y2: 43,
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 62 H38 L52 68 H66 C70 68 70 63 66 63 H54",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 62 L54 63 L72 55",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorManagement);
export default __webpack_public_path__ + "static/media/donor-management.c0e2ec453ca27f717dfbad3c36997a92.svg";
export { ForwardRef as ReactComponent };